/**
 * Synthwave-Hintergrund (Design-System §4): Sternenhimmel, Sonnen-Glow,
 * Berg-Silhouette, Horizontlinie, Perspektiv-Grid, Vignette, Scanlines.
 * Nur auf Login und Homescreen – App-Innenseiten bleiben ruhig.
 */
const RIDGE =
  '0,420 110,250 250,330 400,150 560,300 760,110 940,280 1130,190 1330,80 1540,280 1760,170 ' +
  '1980,60 2210,250 2430,150 2660,300 2880,150 3110,280 3340,170 3560,320 3720,210 3840,300';

export function SynthwaveBg({ grid = true }: { grid?: boolean }) {
  return (
    <>
      <div className="bg" aria-hidden="true">
        <div className="bg__stars" />
        <div className="bg__sun" />
        <svg className="bg__mountains" viewBox="0 0 3840 420" preserveAspectRatio="none">
          <polygon points={`${RIDGE} 3840,420`} fill="#0a0618" opacity="0.92" />
          <polyline
            points={RIDGE}
            fill="none"
            stroke="hsla(172,100%,50%,.55)"
            strokeWidth="4"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
        <div className="bg__horizon" />
        {grid && (
          <>
            <div className="bg__gridwrap">
              <div className="bg__grid" />
            </div>
            <div className="bg__gridfade" />
          </>
        )}
      </div>
      <div className="bg__vignette" aria-hidden="true" />
      <div className="bg__scanlines" aria-hidden="true" />
    </>
  );
}
